import {
  FETCH_POS_TERMINALS,
  FETCH_POS_TERMINAL,
  CREATE_POS_TERMINAL,
  UPDATE_POS_TERMINAL,
  DELETE_POS_TERMINAL,
  FETCH_POS_TRANSACTIONS,
  FETCH_POS_TRANSACTION,
  CREATE_POS_TRANSACTION,
  ADD_PAYMENT_TO_TRANSACTION,
  REFUND_TRANSACTION,
  VOID_TRANSACTION,
  FETCH_POS_SALES_REPORT
} from '../actions/constants';

const initialState = {
  terminals: [],
  terminal: null,
  transactions: [],
  transaction: null,
  salesReport: [],
  currentPage: 1,
  numberOfPages: 1,
  isLoading: false,
  error: null
};

const posReducer = (state = initialState, action) => {
  switch (action.type) {
    // POS Terminal actions
    case FETCH_POS_TERMINALS:
      return {
        ...state,
        terminals: action.payload?.data || [],
        currentPage: action.payload?.currentPage || 1,
        numberOfPages: action.payload?.numberOfPages || 1,
        isLoading: false,
        error: null
      };
    
    case FETCH_POS_TERMINAL:
      return {
        ...state,
        terminal: action.payload,
        isLoading: false,
        error: null
      };
    
    case CREATE_POS_TERMINAL:
      // Ensure we have a valid array
      const currentTerminals = Array.isArray(state.terminals) ? state.terminals : [];
      
      return {
        ...state,
        terminals: [...currentTerminals, action.payload],
        isLoading: false,
        error: null
      };
    
    case UPDATE_POS_TERMINAL:
      return {
        ...state,
        terminals: (state.terminals || []).map((terminal) =>
          terminal._id === action.payload._id ? action.payload : terminal
        ),
        terminal: action.payload,
        isLoading: false,
        error: null
      };
    
    case DELETE_POS_TERMINAL:
      return {
        ...state,
        terminals: (state.terminals || []).filter((terminal) => terminal._id !== action.payload),
        isLoading: false,
        error: null
      };
    
    // POS Transaction actions
    case FETCH_POS_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.data || [],
        currentPage: action.payload.currentPage || 1,
        numberOfPages: action.payload.numberOfPages || 1,
        isLoading: false,
        error: null
      };
    
    case FETCH_POS_TRANSACTION:
      return {
        ...state,
        transaction: action.payload.data,
        isLoading: false,
        error: null
      };
    
    case CREATE_POS_TRANSACTION:
      return {
        ...state,
        transactions: [...(state.transactions || []), action.payload],
        transaction: action.payload,
        isLoading: false,
        error: null
      };
    
    case ADD_PAYMENT_TO_TRANSACTION:
    case REFUND_TRANSACTION:
    case VOID_TRANSACTION:
      return {
        ...state,
        transactions: (state.transactions || []).map((transaction) =>
          transaction._id === action.payload._id ? action.payload : transaction
        ),
        transaction: action.payload,
        isLoading: false,
        error: null
      };
    
    case FETCH_POS_SALES_REPORT:
      return {
        ...state,
        salesReport: action.payload || [],
        isLoading: false,
        error: null
      };
    
    default:
      return state;
  }
};

export default posReducer;
